import React, { Component } from 'react'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MoreHoriz from '@material-ui/icons/MoreHoriz';

import View from 'react-flexbox'
import { DialogPesquisa, EditorCodeField } from 'scorpion-core';


export default class EditorCodigo extends Component {
    constructor(props) {
        super(props);
    }


    render() {

        const { value, onChange } = this.props

        return (
            <View style={{ height: 250 }}>
                <EditorCodeField
                    input={{ value, onChange }}
                    meta={{ touched: "", error: "" }}
                    fullWidth
                />
                <Button onClick={() => this.dialog.show()}>
                    <MoreHoriz />
                </Button>
                <DialogPesquisa forwardedRef={node => this.dialog = node}>

                    <EditorCodeField
                        input={{ value, onChange }}
                        meta={{ touched: "", error: "" }}
                        fullWidth
                    />

                </DialogPesquisa>

            </View>

        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/editor/EditorCodigo.js